module.exports = __webpack_public_path__ + "5248be95995f79f9ca03227aca718ca8.jpg";